import { ChipType } from '@internal/plugin-components-react';
import { AlertType } from './types';

export const toCamelCase = (str) => {
  return str
    .replace(/[-_]+/g, ' ')
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
      return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
    .replace(/\s+/g, '');
};

export const toCamelCaseObject = (
  obj,
) => {
  const newObj = {};
  for (const [key, value] of Object.entries(obj)) {
    const camelKey = toCamelCase(key);
    newObj[camelKey] = value;
  }
  return newObj;
};

export const changeObjToURLParams = (jsonObj) => {
  return Object.entries(jsonObj)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`,
    )
    .join('&');
};

export const areObjectsEqual = (
  obj1,
  obj2,
) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let i = 0; i < keys1.length; i++) {
    const key = keys1[i];
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
};


export function debounce(
  func,
  delay,
) {
  let timeoutId;

  return function debounced( ...args) {
    const context = this;

    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

export function testRegex(regex) {
  try {
    const re = new RegExp(regex);
    re.test('');
    return true;
  } catch (error) {
    return false;
  }
}

export const processClusterID = 

(
  data,
) => {
  const processedData = data.map(item => {
    const clusterIdParts = item.cluster_id.split(':');
    const clusterName = clusterIdParts.slice(1).join('-');

    return {
      ...item,
      cluster_name: clusterName,
    };
  });
  return processedData;
};

export const formatPhoneNumber = (phone) => {
  const phoneNumber = phone.replace(/\D/g, '');

  // Reformat the string to phone number format
  const formattedPhoneNumber = phoneNumber.replace(
    /(\d{1,4})(\d{1,4})?(\d{1,4})?/,
    (_, p1, p2, p3) => {
      let parts = [];
      if (p1) parts.push(p1);
      if (p2) parts.push(p2);
      if (p3) parts.push(p3);
      return parts.join('-');
    },
  );

  return formattedPhoneNumber;
};

export const deductAlertType = (type) => {
  switch (type) {
    case AlertType.CRITICAL:
      return 'critical';
    case AlertType.WARNING:
      return 'warning';
    case AlertType.NOTIFICATION:
      return 'notification';
    default:
      return type;
  }
};

export const getAlertTypeChipProps = (status) => {
  let value = {
    type: ChipType.blue,
    text: 'notification',
  };
  switch (status) {
    case AlertType.CRITICAL:
      value.type = ChipType.error;
      value.text = deductAlertType(status);
      break;
    case AlertType.WARNING:
      value.type = ChipType.warning;
      value.text = deductAlertType(status);
      break;
    default:
      break;
  }
  return value;
};
